import axios from 'axios';
import { serverUrl } from '../../components/Helpers/Config';
import { tokenAuthorize } from '../../components/Helpers/Common';

export const REFLECTION = 'REFLECTION';
export const REFLECTION_FEEDBACK = 'REFLECTION_FEEDBACK';
export const REFLECTION_FEEDBACK_HISTORY = 'REFLECTION_FEEDBACK_HISTORY';
export const REFLECTION_FEEDBACK_PROCESSING = 'REFLECTION_FEEDBACK_PROCESSING';

export const getReflectionFeedbackModels = () => {
    return (dispatch, getState) => {
        return axios.get(serverUrl.ReflectionFeedBackModels).then(resp => {
            if (resp.status === 200) {
                let reflection = resp.data.results
                dispatch({ type: REFLECTION, payload: { reflection } });
            }
        }).catch((err) => {
            tokenAuthorize(err?.response?.status);
        })
    }
}
export const getReflectionFeedbackHistory = (bool) => {
    return (dispatch, getState) => {
        dispatch({ type: REFLECTION_FEEDBACK_HISTORY, payload: bool });
    }
}
export const getReflectionFeedbackProcessing = (bool) => {
    return (dispatch, getState) => {
        dispatch({ type: REFLECTION_FEEDBACK_PROCESSING, payload: bool });
    }
}